import networkObservability from "public/network-services/network-observability.png";

export const INTRO_CONSTANTS = {
  title: "Network Observability & Monitoring, Designed for Control",
  description: [
    "Network observability and monitoring go beyond basic uptime checks—they provide the intelligence needed to maintain performance, ensure security, and prevent disruptions.",
    "OneMind’s solution delivers real-time visibility, automated analytics, and deep insight into every layer of your network. From identifying anomalies to enforcing compliance, every component is designed to help you act before issues impact operations.",
    "Whether supporting cloud, hybrid, or distributed environments, the goal is simple: understand what’s happening, why it’s happening, and resolve it—before it becomes a problem.",
  ],
  image: networkObservability,
  imageHeight: "340px",
};
